module.exports = __webpack_public_path__ + "static/media/icn_mainnav_collections_light.4dd556be.svg";